import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader/root';
import { Router, Route, Switch } from 'react-router-dom';
import ReactGa from 'react-ga';
import { createBrowserHistory } from 'history';
import { ToastContainer } from 'react-toastify';
import Landing from './components/landing';
import NewPlay from './components/roguelite/index';
import Streaming from './components/streaming/index';
import ChugWars from './components/chugWars/index';
import '../node_modules/react-toastify/dist/ReactToastify.min.css';

const App = () => {
  const history = createBrowserHistory();
  ReactGa.initialize('UA-176997892-1');
  history.listen((location) => {
    ReactGa.set({ page: location.pathname });
    ReactGa.pageview(location.pathname);
  });
  useEffect(() => {
    ReactGa.pageview(window.location.pathname + window.location.search);
  }, [history]);
  return (
    <main>
      <Router history={history}>
        <Switch>
          <Route path="/" component={Landing} exact />
          <Route path="/play" component={NewPlay} />
          <Route path="/streaming/:layout" component={Streaming} />
          <Route path="/chugWars" component={ChugWars} />
        </Switch>
      </Router>
      <ToastContainer autoClose={2000} />
    </main>
  );
};

export default hot(App);
